module.exports = __webpack_public_path__ + "static/media/shot-camera-btn.5b3c0695.svg";